import script from "./RegulationsApproval.vue?vue&type=script&setup=true&lang=js"
export * from "./RegulationsApproval.vue?vue&type=script&setup=true&lang=js"

import "./RegulationsApproval.vue?vue&type=style&index=0&id=d7a99b9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7a99b9e"]])

export default __exports__